export function getOrdinalSuffix(position: number): string {
  const suffixes = ['th', 'st', 'nd', 'rd']
  const mod100 = position % 100
  return (suffixes[(mod100 - 20) % 10] || suffixes[mod100] || suffixes[0]) ?? ''
}
